import React from 'react';
import { X } from 'lucide-react';
import { Button } from '@/Components/shadcn/button';
import { Spinner } from '@/Components/shadcn/spinner';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/Components/shadcn/tooltip';
import { ImageCropStrings } from './ImageCropUtils';
import { ImageCropContextProps } from './ImageCropContext';

export interface ImageCropRemoveButtonProps
    extends Pick<ImageCropStrings, 'removeButtonTooltipText'>, Pick<ImageCropContextProps, 'processing'> {
    onClick: () => void;
}

export const ImageCropRemoveButton = ({
    onClick,
    processing,
    removeButtonTooltipText,
}: ImageCropRemoveButtonProps): React.JSX.Element => {
    return (
        <TooltipProvider>
            <Tooltip>
                <TooltipTrigger asChild>
                    <Button
                        type="button"
                        data-cy="ImageCropRemoveButton"
                        variant="ghost"
                        disabled={processing}
                        onClick={onClick}
                        className="bg-background size-7.5 rounded-full p-2 shadow-md hover:bg-red-400"
                    >
                        {processing ? (
                            <Spinner className="size-4.5" />
                        ) : (
                            <X className="text-muted-foreground size-4.5" data-testid="CloseIcon" />
                        )}
                    </Button>
                </TooltipTrigger>
                <TooltipContent side="top">
                    <span className="text-xs">{removeButtonTooltipText}</span>
                </TooltipContent>
            </Tooltip>
        </TooltipProvider>
    );
};
